export const APPLICATION_MANAGEMENT_GATE = 'application_management'
export const PMU_PORTAL_GATE = 'enable_pmu_portal'
